/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  SwipeableDrawer,
  Box,
  Typography,
  IconButton,
  CircularProgress,
} from '@material-ui/core';
import {
  MuiThemeProvider,
  ThemeProvider,
  useTheme,
} from '@material-ui/core/styles';
import { IchhyaTheme, GlobalStyle } from '../theme';
import Close from '@material-ui/icons/Close';
import Header from './header';
import Footer from './footer';
import './layout.css';
import { NavData } from './data';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

library.add(fab, fas);

const StyledLink = styled(Link)`
  color: #009688;
  &:hover {
    color: grey;
  }
`;

const NavLink = ({ to, text, onClick }) => (
  <Box px="24px" py="16px" onClick={() => onClick()}>
    <StyledLink to={to}>
      <Typography
        variant="h5"
        style={{ fontFamily: 'Martel', fontWeight: 600 }}
      >
        {text}
      </Typography>
    </StyledLink>
  </Box>
);

const Layout = ({ children }) => {
  const [boxHeight, setBoxHeight] = useState();
  const [loadingState, setLoadingState] = useState(false);
  const [toggleDrawer, setToggleDrawer] = useState(false);

  useEffect(() => {
    if (!window) setLoadingState(true);
    if (window) {
      setBoxHeight(window.innerHeight - 110);
      setLoadingState(false);
    }
  }, []);
  return (
    <ThemeProvider theme={IchhyaTheme}>
      <MuiThemeProvider theme={IchhyaTheme}>
        <GlobalStyle />
        <Box display="flex" flexDirection="column" height={1}>
          {boxHeight && (
            <>
              <Header onClick={() => setToggleDrawer(true)} />
              <Box
                maxHeight={boxHeight}
                style={{ overflowY: 'scroll' }}
              >
                {children}
                <Footer />
              </Box>
            </>
          )}
        </Box>
        <SwipeableDrawer
          anchor="right"
          open={toggleDrawer}
          onOpen={() => setToggleDrawer(true)}
          onClose={() => setToggleDrawer(false)}
        >
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <IconButton
              color="inherit"
              onClick={() => setToggleDrawer(false)}
            >
              <Close />
            </IconButton>
          </Box>
          <Box
            style={{ width: 250, height: '100%' }}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            {NavData.map((d, i) => {
              if (d.to.includes('#self-assessment'))
                return (
                  <NavLink
                    key={i}
                    to={'questionnaire'}
                    text={d.text}
                    onClick={() => setToggleDrawer(false)}
                  />
                );
              return (
                <NavLink
                  key={i}
                  to={d.to}
                  text={d.text}
                  onClick={() => setToggleDrawer(false)}
                />
              );
            })}
          </Box>
        </SwipeableDrawer>
      </MuiThemeProvider>
    </ThemeProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
